import { render, staticRenderFns } from "./ContentViewData.vue?vue&type=template&id=540af7bc"
import script from "./ContentViewData.vue?vue&type=script&lang=js"
export * from "./ContentViewData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports